import React from "react";
import SearchInputField from "components/SearchInputField";
import { ReactComponent as SearchIcon } from "assets/img/icons/search.svg";

function MicrosoftTeamSearch({
  filterTeam,
  loading,
  setDisplayGeneralTab,
  setFilterLoading,
  searchTeam,
  setSearchTeam,
  searchedTName,
  resetSearchName,
  getTeams,
}) {
  const handleSearched = async (searchValue) => {
    await filterTeam({ name: searchValue });
    setSearchTeam(true);
  };

  const resetSearched = async () => {
    setFilterLoading(true);
    await getTeams();
    setDisplayGeneralTab(true);
    resetSearchName();
    setFilterLoading(false);
    if (searchTeam) setSearchTeam(false);
  };

  return (
    <>
      {!loading && (
        <div className="team-search-input msTeam-search">
          <SearchInputField
            value={searchedTName}
            handleSearched={handleSearched}
            placeholder={"Search Team By Name"}
            Icon={SearchIcon}
          />
          {searchTeam && (
            <div className="resetTeamSearch">
              <span onClick={resetSearched} className="resetIcon">
                Reset
              </span>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default MicrosoftTeamSearch;
